import { Button } from '@components/ui/button';
import type { SubmissionShort } from '@queries/fetchSubmissions';

interface ContractListItemProps {
  contract: SubmissionShort;
  onAdd: (contract: SubmissionShort) => void;
}

export function ContractListItem({ contract, onAdd }: ContractListItemProps) {
  return (
    <li className="flex items-center justify-between gap-3 overflow-hidden px-1 py-2.5">
      <p className="truncate text-sm leading-5 font-normal text-gray-700">{contract.name}</p>
      <Button type="button" variant="primary" size="sm" onClick={() => onAdd(contract)}>
        Add
      </Button>
    </li>
  );
}
